<template>
	<div style="background: #f3f4f7" v-loading.fullscreen.lock="fullscreenLoading">
		<userHeader />
		<fuHeader />
		<crumbs :txt="a" type="3" height="43px" />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="gxBox">
				<div class="gxBoxL" v-if="treFlag">
					<tree :treeData="treeData" @perList="perList" :defaultProps="defaultProps" />
				</div>
	
				<div class="gxBoxR">
					<div class="gxBoxRT" v-if="!yzType || !treFlag">
						<div class="gxBoxRTit">
							<h2>{{ txtFn }}推荐</h2>
							<span @click="czFn">
								<img src="@/assets/img/sxIcon.svg" alt="" />
								重置
							</span>
						</div>
						<div class="gxBoxRTbox">
							<div class="gxBoxRTitem" :class="{ active: keywords.includes(item) }" @click="tabFn(item)" v-for="(item, index) in tabList" :key="index">
								{{ item }}
							</div>
						</div>
					</div>
					<div class="gxBoxRB">
						<div class="zzAdminTabs">
							<div class="zzAdminTab">
								<div class="zzAdminItem" @click="tabFns(0)" :class="tabFlag == 0 ? 'active' : ''">综合</div>
								<div class="zzAdminItem" @click="tabFns(1)" :class="tabFlag == 1 ? 'active' : ''">最新</div>
								<div class="zzAdminItem" @click="tabFns(2)" :class="tabFlag == 2 ? 'active' : ''">最热</div>
							</div>
							<div class="zzAdminTabZj">
								{{ txtFn }}共
								<span>{{ total }}</span>
								个结果
							</div>
						</div>
						<div class="zzAdminConts">
							<div class="zzAdminCont" v-if="perData.length">
								<div class="zzAdminG supHove5" v-for="(item, index) in perData" :key="index">
									<div class="zzAdminItemImg" :class="classType == 8 ? 'zzAdminItemImg2' : ''" v-if="yzType != 2 || !treFlag" @click="btnFn(item)">
										<el-image v-if="classType != 8" :src="txtFn == '每日一听' ? $imgFn('试卷', 2) : $imgFn(item.resourceFileName, 1)" lazy></el-image>
										<el-image v-if="classType == 8" :src="$imgUrl + item.coverImg" lazy></el-image>
									</div>
									<div class="zzAdminItemImg zzAdminItemImg1" v-if="yzType == 2 && treFlag" @click="btnFn(item)">
										<el-image :src="$imgFn(item.resourceFileName, 1)" lazy></el-image>
									</div>
									<div class="zzAdminItemP" v-if="type == 1" @click="btnFn(item)">
										<div class="zzAdminItemTit">
											<p class="ellipsis-1" :title="item.title">{{ item.title }}</p>
											<div class="infoMyIcon" v-if="yzType != 2">
												<img src="@/assets/img/jf.svg" alt="" />
												<span>{{ item.points }}</span>
											</div>
											<div class="infoMyVip infoMyPut" v-if="yzType == 2 && item.limitsAuthority == 0">
												<i class="el-icon-user-solid"></i>
												<span>普通老师</span>
											</div>
											<div class="infoMyVip" v-if="yzType == 2 && item.limitsAuthority == 1">
												<img src="@/assets/img/hys.svg" alt="" />
												<span>会员老师</span>
											</div>
											<div class="zzAdminItemYuy" v-if="yzType == 2" @click.stop="scFn(item)" :class="item.isCollect ? 'active' : ''">
												<img src="@/assets/img/sc (4).svg" v-show="!item.isCollect" alt="" />
												<img src="@/assets/img/sc (2).svg" v-show="item.isCollect" alt="" />
												<span>{{ item.isCollect ? '已收藏' : '收藏' }}</span>
											</div>
										</div>
										<div class="zzAdminItemJj" v-if="yzType != 2 || !treFlag" :style="{ marginTop: classType == 8 ? '6px' : '' }">
											<div
												class="zzAdminItemJjI"
												:class="`zzAdminItemJjI${(tabList.indexOf(i) + 1) % 6}`"
												v-for="(i, index) in item.keywords?.split(',')"
												:key="index"
											>
												{{ i }}
											</div>
										</div>
										<div
											class="zzAdminItemCont"
											:title="$extractText($txtGs(item.content))"
											v-html="$extractText($txtGs(item.content))"
											v-if="yzType != 2 && classType != 8"
										></div>
										<div class="zzAdminItemFot" :style="{ marginTop: yzType == 2 && treFlag ? '16px' : classType == 8 ? '4px' : '' }">
											<!-- <div class="zzAdminItemDel zzAdminItemDel1 supHove3" @click="xzBtn(item)" v-if="classType == 8">下载</div> -->
											<div class="zzAdminItemk">
												<img src="@/assets/img/xiazai.svg" alt="" />
												<span>下载量：{{ item.downloadNum || 0 }}</span>
											</div>
											<div class="zzAdminItemk">日期：{{ (item.releaseTime || item.createTime) | momentYR('YYYY年MM月DD日') }}</div>
											<!-- <div class="zzAdminItemk" v-if="classType!=8">
						  编写人：{{item.createNickName}}
						</div> -->
										</div>
									</div>
									<div class="zzAdminItemP" v-if="type == 2" @click="btnFn(item)">
										<div class="zzAdminItemTit">
											<p class="ellipsis-1" :title="item.title">{{ item.title }}</p>
											<div class="infoMyIcon" v-if="classType == 10">
												<img src="@/assets/img/jf.svg" alt="" />
												<span>{{ item.points }}</span>
											</div>
											<div class="zzAdminItemYuy" v-if="yzType == 2 || classType == 9" @click.stop="scFn(item)" :class="item.isCollect ? 'active' : ''">
												<img src="@/assets/img/sc (4).svg" v-show="!item.isCollect" alt="" />
												<img src="@/assets/img/sc (2).svg" v-show="item.isCollect" alt="" />
												<span>{{ item.isCollect ? '已收藏' : '收藏' }}</span>
											</div>
										</div>
										<div class="zzAdminItemJj">
											<div class="zzAdminItemJjI" :class="`zzAdminItemJjI${(index + 1) % 6}`" v-for="(i, index) in item.keywords?.split(',')" :key="index">
												{{ i }}
											</div>
										</div>
										<div class="zzAdminItemCont" :title="item.intro" v-html="item.intro" v-if="classType == 10"></div>
										<div class="zzAdminItemFot zzAdminItemFot1" v-if="classType == 9">
											<div class="zzAdminItemk">
												<img src="@/assets/img/st.svg" alt="" />
												<span>试题数量：{{ item.questionNum }}题</span>
											</div>
											<div class="zzAdminItemk">
												<img src="@/assets/img/dati.svg" alt="" />
												<span>答题时间：{{ Math.floor(item.answerTime / 60) }}分钟</span>
											</div>
											<div class="zzAdminItemk">
												<img src="@/assets/img/stzf.svg" alt="" />
												<span>试题总分：{{ item.score }}分</span>
											</div>
										</div>
										<div class="zzAdminItemFot">
											<div class="zzAdminItemk">
												<img src="@/assets/img/xiazai.svg" v-if="classType == 10" alt="" />
												<span v-if="classType == 10">下载量：{{ item.downloadNum || 0 }}</span>
												<img src="@/assets/img/zfl.svg" v-if="classType == 9" alt="" />
												<span v-if="classType == 9">转发量：{{ item.forwarding || 0 }}</span>
											</div>
											<div class="zzAdminItemk" v-if="classType == 10">日期：{{ (item.releaseTime || item.createTime) | momentYR('YYYY年MM月DD日') }}</div>
											<div class="zzAdminItemk" v-if="classType != 10">有效日期：{{ item.endTime | momentYR('YYYY年MM月DD日') }}</div>
											<!-- <div class="zzAdminItemk">
						  编写人：{{item.createNickName}}
						</div> -->
										</div>
									</div>
									<div class="zzAdminItemDel supHove3" @click="xzBtn(item)" v-if="classType != 9 && classType != 8">下载</div>
									<div class="zzAdminItemDel supHove3" @click="xzBtn(item)" v-if="type == 1 && classType == 8">下载</div>
									<div class="zzAdminItemDel supHove3" @click.stop="btnFn(item)" v-if="classType == 9">预览试题</div>
								</div>
							</div>
							<fenye v-if="perData.length" :total="total" ref="fybox" @dataFn="perList" />
							<div v-if="!perData.length">
								<el-empty description="暂无数据"></el-empty>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import userHeader from '@/components/hearder/userHeader';
import fuHeader from '@/components/hearder/fuHeader';
import fenye from '@/components/pubComponents/fenye';
import tree from '@/components/pubComponents/tree';
import crumbs from '@/components/hearder/crumbs';

// 导入streamsaver
import { batchDownload } from '@/assets/js/xz';
let names = '首页';

export default {
	name: 'gongxiangHz',
	data() {
		return {
			type: 1, // 1 共享互助
			txt: '',
			defaultProps: '',
			treFlag: true,
			a: [],
			tabList: [],
			tabFlag: 0, // 0综合 1最新 2 最热
			classType: 2, // 1 同步课件 2 最新试卷 3 优质课件 4 荐阅外刊 5 双语节目 6 英语小说 7 优质课 8 双语新闻 9 每日一听 10共享互助
			perData: [],
			treeData: [
				{
					resourceClassificationName: ''
				}
			],
			total: 0,
			sortComprehensive: '',
			yzType: '', //1有关键字 2无关键字
			flags: '',
			fullscreenLoading: false,
			keywords: ''
		};
	},
	components: {
		userHeader,
		foot,
		fuHeader,
		fenye,
		crumbs,
		tree
	},
	watch: {
		'$route.query': {
			handler(newVal, oldVal) {
				console.log(newVal, 33333);
				const { type, txt, flags, yzType, classType, treFlag, tabFtxt } = newVal;
				if (tabFtxt) {
					this.a = typeof tabFtxt == 'string' ? [names, tabFtxt] : tabFtxt;
				}
				this.treFlag = treFlag === 'false' ? false : true;
				this.type = type || 1;
				this.classType = classType || 2;
				this.txt = txt || '';
				this.yzType = yzType || '';
				this.flags = flags || '';
				this.init();
			},
			deep: true // 如果需要深度监听，例如对象内部属性的变化。这里通常用于复杂对象或数组。对于简单的参数变化，可以忽略这个选项。
		}
	},
	computed: {
		txtFn() {
			// 1 同步课件 2 最新试卷 3 优质课件 4 荐阅外刊 5 双语节目 6 英语小说 7 优质课 8 双语新闻
			let val = '关键字';
			switch (this.classType) {
				case '1':
					val = '同步课件';
					break;
				case '2':
					val = '最新试卷';
					break;
				case '3':
					val = '优质课件';
					break;
				case '4':
					val = '荐阅外刊';
					break;
				case '5':
					val = '双语节目';
					break;
				case '6':
					val = '英语小说';
					break;
				case '7':
					val = '优质课';
					break;
				case '8':
					val = '双语新闻';
					break;
				case '9':
					val = '每日一听';
					break;
				case '10':
					val = '共享互助';
					break;
				case '11':
					val = '扩展阅读';
					break;
			}
			return val;
		}
	},
	methods: {
		async xzBtn(item) {
			if (item.resourceFileId || item.videoResourceFileId || item.audioResourceFileId) {
				if (item.limitsAuthority == 1) {
					if (JSON.parse(localStorage.getItem('useInfo')).authority == 0) {
						this.$message({
							message: '您现在是非会员用户，暂不能下载会员资源喔~',
							type: 'warning'
						});
						return;
					}
				}
				let id = '';
				let type = '';
				if (item.documentResourceId) {
					id = item.documentResourceId;
					type = 1;
				}
				if (item.toolResourceId) {
					id = item.toolResourceId;
					type = 3;
				}
				if (item.mutualAidResourceId) {
					id = item.mutualAidResourceId;
					type = 2;
				}
				if (item.videoResourceFileId || item.audioResourceFileId) {
					console.log(111);
					let files = [];
					let arr = []
					if (item.videoResourceFileId) {
						arr.push(item.videoResourceFileId)
					}
					if (item.audioResourceFileId) {
						arr.push(item.audioResourceFileId)
					}
					if (item.resourceFileId) {
						arr = arr.concat(String(item.resourceFileId).split(','));
					}
					// 给数组循环赋值
					this.fullscreenLoading = true;
					let stop = false
					let newArr = arr.map(async (is, index) => {
						let res = await this.$http.get('api/app/common/getUrl', {
							params: {
								fileId: is,
								id: index == 0 ? id : '',
								type: index == 0 ? type : '',
								downloadFlag: true,
								clientType: 1
							}
						}); // 年龄赋值等待
						console.log('res: ',res);
						if (res.code != 200) {
							stop = true
						}
						return {
							name: res.fileName,
							url: res.msg
						};
					});
					// Promise接收一个数组
					let newArrs = await Promise.all(newArr);
					console.log('stop: ',stop);
					this.fullscreenLoading = false;
					if (stop) {
						return
					}
					batchDownload(item.title, newArrs);
				} else {
					console.log(222);
					// if (item.resourceFileId.includes(',')) {
					console.log(333);
					let arr = String(item.resourceFileId).split(',');
					// 给数组循环赋值
					this.fullscreenLoading = true;
					let stop = false
					let newArr = arr.map(async (is, index) => {
						let res = await this.$http.get('api/app/common/getUrl', {
							params: {
								fileId: is,
								id: index == 0 ? id : '',
								type: index == 0 ? type : '',
								downloadFlag: true,
								clientType: 1
							}
						}); // 年龄赋值等待
						console.log('res: ',res);
						if (res.code != 200) {
							stop = true
						}
						return {
							name: res.fileName,
							url: res.msg
						};
					});
					
					// Promise接收一个数组
					let newArrs = await Promise.all(newArr);
					console.log('stop: ',stop);
					this.fullscreenLoading = false;
					if (stop) {
						return
					}
					// 执行完毕，再往下走
					console.log('最终加工好的数组结果：', newArrs);
					batchDownload(item.title, newArrs);
					// } else {
					// 	console.log(444);
					// 	this.$xzFn(
					// 		{
					// 			fileId: item.resourceFileId,
					// 			id,
					// 			clientType: 1,
					// 			type: type
					// 		},
					// 		(res) => {}
					// 	);
					// }
				}
			} else {
				this.$message({
					message: '暂无附件哦~',
					type: 'warning'
				});
			}
		},
		// async xzBtn(item) {
		// 	if (this.yzType == 2 && item.limitsAuthority == 1 && this.classType !== 8) {
		// 		if (JSON.parse(localStorage.getItem('useInfo')).authority == 0) {
		// 			this.$message({
		// 				message: '您现在是非会员用户，暂不能下载会员资源喔~',
		// 				type: 'warning'
		// 			});
		// 			return;
		// 		}
		// 	}
		// 	let id = '';
		// 	let type = '';
		// 	if (this.classType == 10) {
		// 		id = item.mutualAidResourceId;
		// 		type = 2;
		// 	} else {
		// 		id = item.documentResourceId;
		// 		type = 1;
		// 	}
		// 	console.log(item, 'sss');
		// 	if (item.videoResourceFileId || item.audioResourceFileId) {
		// 		let files = [];
		// 		if (item.videoResourceFileId) {
		// 			await this.$http
		// 				.get('api/app/common/getUrl', {
		// 					params: {
		// 						fileId: item.videoResourceFileId,
		// 						id,
		// 						type,
		// 						clientType: 1
		// 					}
		// 				})
		// 				.then((res) => {
		// 					if (res.code == 200) {
		// 						files.push({
		// 							name: res.fileName,
		// 							url: res.msg
		// 						});
		// 					}
		// 				});
		// 		}
		// 		if (item.audioResourceFileId) {
		// 			await this.$http
		// 				.get('api/app/common/getUrl', {
		// 					params: {
		// 						fileId: item.audioResourceFileId,
		// 						clientType: 1
		// 					}
		// 				})
		// 				.then((red) => {
		// 					if (red.code == 200) {
		// 						files.push({
		// 							name: red.fileName,
		// 							url: red.msg
		// 						});
		// 					}
		// 				});
		// 		}
		// 		await this.$http
		// 			.get('api/app/common/getUrl', {
		// 				params: {
		// 					fileId: item.resourceFileId,
		// 					clientType: 1
		// 				}
		// 			})
		// 			.then((red) => {
		// 				if (red.code == 200) {
		// 					item.downloadNum += 1;
		// 					files.push({
		// 						name: red.fileName,
		// 						url: red.msg
		// 					});
		// 				}
		// 			});
		// 		batchDownload(item.title, files);
		// 	} else {
		// 		this.$xzFn(
		// 			{
		// 				fileId: item.resourceFileId,
		// 				id,
		// 				clientType: 1,
		// 				type
		// 			},
		// 			(res) => {
		// 				item.downloadNum += 1;
		// 			}
		// 		);
		// 	}
		// },
		czFn() {
			this.keywords = '';
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		scFn(item) {
			if (this.classType == 9) {
				this.$scFn(
					{
						type: '6',
						assetsId: item.listenEveryDayId
					},
					item.isCollect,
					this.perList,
					{
						pageNum: this.$refs['fybox']?.pageNum,
						pageSize: this.$refs['fybox']?.pageSize,
						types: 1
					}
				);
			} else {
				this.$scFn(
					{
						type: '2',
						assetsId: item.documentResourceId
					},
					item.isCollect,
					this.perList,
					{
						pageNum: this.$refs['fybox']?.pageNum,
						pageSize: this.$refs['fybox']?.pageSize,
						types: 1
					}
				);
			}
		},
		tabFns(type) {
			this.tabFlag = type;
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		tzBtn(type, qu) {
			this.$nextTick(() => {
				this.$router.push({
					path: type,
					query: {
						...qu
					}
				});
			});
		},
		tabFn(item) {
			if (this.classType == 11) {
				sessionStorage.removeItem('classificationId');
				if (item == '双语节目') {
					this.tzBtn('gongxiangHz', { yzType: '2', classType: 5, treFlag: false, tabFtxt: [...this.a, '双语节目'] });
				} else if (item == '英文小说') {
					this.tzBtn('gongxiangHz', { yzType: '2', classType: 6, treFlag: false, tabFtxt: [...this.a, '英文小说'] });
				} else if (item == '荐阅外刊') {
					this.tzBtn('gongxiangHz', { yzType: '2', classType: 4, treFlag: false, tabFtxt: [...this.a, '荐阅外刊'] });
				} else if (item == '优质课') {
					this.tzBtn('gongxiangHz', { yzType: '2', classType: 7, treFlag: false, tabFtxt: [...this.a, '优质课'] });
				}
				return;
			}
			if (this.keywords.includes(item)) {
				this.keywords = this.keywords.replace(item + ',', '');
			} else {
				this.keywords += item + ',';
			}
			if (this.$refs['fybox']) {
				this.$refs['fybox'].pageNum = 1;
				this.$refs['fybox'].pageSize = 10;
			}
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		init() {
			if (this.treFlag) {
				console.log('有树');
				if (this.classType == 9) {
					this.defaultProps = {
						children: 'children',
						label: 'classificationName'
					};
					this.$http
						.get('api/app/yydQuestionClassification/list', {
							params: {
								categories: 4
							}
						})
						.then((res) => {
							if (res.code == 200) {
								this.treeData = res.data;
								console.log(this.treeData, 222);
							}
						});
				} else {
					this.defaultProps = {
						children: 'children',
						label: 'resourceClassificationName'
					};
					// 树 资源1 同步课件 2 优质课件 3 最新试卷 4 互助资源 5 工具资源
					this.$http
						.get('api/app/yydResourceClassification/list', {
							params: {
								categories: this.classType == 2 ? 3 : this.classType == 1 ? 1 : this.classType == 3 ? 2 : this.classType == 10 ? 4 : 2
							}
						})
						.then((res) => {
							if (res.code == 200) {
								this.treeData = res.data;
								console.log(this.treeData, 222);
							}
						});
				}
			} else {
				// 扩展阅读
				if (this.classType == 11) {
					this.tabList = ['双语节目', '英文小说', '荐阅外刊', '优质课'];
				} else {
					// 1 同步课件 2 最新试卷 3 优质课件 4 荐阅外刊 5 双语节目 6 英语小说 7 优质课 8 双语新闻
					console.log('有关键字');
					this.$http
						.get('api/app/yydDocumentResource/documentResourceIdKeywords/list', {
							params: {
								type: this.classType
							}
						})
						.then((res) => {
							if (res.code == 200) {
								if (this.classType == 8 || this.classType == 5 || this.classType == 6 || this.classType == 4 || this.classType == 7) {
									this.tabList = res.data.map((item) => {
										return item.resourceKeywordsName;
									});
								} else {
									this.tabList = res.data.map((item) => {
										return item.resourceClassificationName;
									});
								}
								console.log(this.tabList, 8888);
							}
						});
				}
			}
			if (this.yzType != 2) {
				console.log('有关键字');
				if (this.classType == 9) {
					// 每日一听关键字
					this.$http.get('api/app/yydListenEveryDay/selectListenEveryDayKeyWords').then((res) => {
						if (res.code == 200) {
							this.tabList = res.data.map((item) => {
								return item.resourceKeywordsName;
							});
							console.log(this.tabList, 8888);
						}
					});
				} else if (this.classType == 10) {
					// 互助资源关键字
					this.$http.get('api/app/yydMutualAidResource/mutualAidResourceKeywords/list').then((res) => {
						if (res.code == 200) {
							this.tabList = res.data.map((item) => {
								return item.resourceKeywordsName;
							});
							console.log(this.tabList, 8888);
						}
					});
				}
			}
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		perList(data) {
			let pre = '';
			if (data.pageNum == 1 && this.tabFlag == 0 && data.types != 1) {
				let randomNum = Math.floor(Math.random() * 1000000);
				this.sortComprehensive = randomNum.toString().padStart(6, '0');
			}
			if (data) {
				console.log(data, 44444444444);
				let { types, classificationId, ...a } = data;
				if (sessionStorage.getItem('classificationId')) {
					classificationId = sessionStorage.getItem('classificationId');
				}
				pre = {
					...a,
					classificationId,
					sortComprehensive: this.classType == 11 ? '' : this.sortComprehensive,
					pageNum: data.pageNum,
					pageSize: this.$refs['fybox']?.pageSize || 10
				};
			} else {
				pre = {
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				};
			}
			this.fullscreenLoading = true;
			if (this.yzType == 2) {
				console.log('文档资源页面');
				let datas = {};
				if (this.classType == 11) {
					this.keywords = '';
					if (this.keywords.length == 0) {
						datas = {
							types: '4,5,6,7',
							sort: this.tabFlag,
							...pre
						};
					} else {
						console.log(this.keywords);
						let types = this.keywords.replace('荐阅外刊', '4').replace('双语节目', '5').replace('英文小说', '6').replace('优质课', '7');
						datas = {
							types,
							sort: this.tabFlag,
							...pre
						};
					}
				} else {
					datas = {
						keywords: this.keywords,
						type: this.classType,
						sort: this.tabFlag,
						...pre
					};
				}
				this.$http
					.get('api/app/yydDocumentResource/list', {
						params: datas
					})
					.then((res) => {
						this.fullscreenLoading = false;
						if (res.code == 200) {
							this.perData = res.rows || [];
							this.total = res.total;
						}
					});
			} else {
				if (this.classType == 9) {
					// 每日一听
					this.$http
						.get('api/app/yydListenEveryDay/list', {
							params: {
								classificationId: this.classificationId,
								keywords: this.keywords,
								sort: this.tabFlag,
								...pre
							}
						})
						.then((res) => {
							this.fullscreenLoading = false;
							if (res.code == 200) {
								this.perData = res.rows || [];
								this.total = res.total;
							}
						});
				} else if (this.classType == 10) {
					// 共享互助
					this.$http
						.get('api/app/yydMutualAidResource/list', {
							params: {
								keywords: this.keywords,
								sort: this.tabFlag,
								...pre
							}
						})
						.then((res) => {
							this.fullscreenLoading = false;
							if (res.code == 200) {
								this.perData = res.rows || [];
								this.total = res.total;
							}
						});
				}
			}
		},
		btnFn(item) {
			if (item.limitsAuthority == 1) {
				if (JSON.parse(localStorage.getItem('useInfo')).authority == 0) {
					this.$message({
						message: '您无权限浏览本页面，请点击需求申请联系辅教员~',
						type: 'warning'
					});
					return;
				}
			}

			if (this.type == 2) {
				if (this.classType == 9) {
					this.$router.push({
						path: './timDec',
						query: {
							type: 1,
							txt: item.title,
							listenEveryDayId: item.listenEveryDayId,
							crumFlag: 1,
							tabFtxt: ['首页', '每日一听']
						}
					});
				} else {
					this.$router.push({
						path: './hbDec',
						query: {
							type: 5,
							flags: 1,
							txt: item.title,
							mutualAidResourceId: item.mutualAidResourceId,
							classType: this.classType,
							yzType: '',
							crumFlag: 1,
							tabFtxt: ['首页', '共享互助']
						}
					});
				}
			} else {
				if (this.classType == 8) {
					this.$router.push({
						path: 'scDec',
						query: {
							type: 2,
							flags: 1,
							txt: item.title,
							documentResourceId: item.documentResourceId,
							crumFlag: 1,
							tabFtxt: ['首页', '双语新闻']
						}
					});
				} else {
					// 1 同步课件 2 最新试卷 3 优质课件 4 荐阅外刊 5 双语节目 6 英语小说 7 优质课 8 双语新闻
					let a = ['首页'];
					if (this.classType == 1) {
						a.push('同步课件');
					} else if (this.classType == 2) {
						a.push('最新试卷');
					} else if (this.classType == 3) {
						a.push('优质课件');
					} else if (this.classType == 4) {
						a.push('扩展阅读');
						a.push('荐阅外刊');
					} else if (this.classType == 5) {
						a.push('扩展阅读');
						a.push('双语节目');
					} else if (this.classType == 6) {
						a.push('扩展阅读');
						a.push('英语小说');
					} else if (this.classType == 7) {
						a.push('扩展阅读');
						a.push('优质课');
					} else if (this.classType == 8) {
						a.push('双语新闻');
					} else if (this.classType == 11) {
						a.push('扩展阅读');
					}
					this.$router.push({
						path: './hbDec',
						query: {
							type: 5,
							flags: 1,
							conTxt: 1,
							txt: item.title,
							classType: this.classType,
							documentResourceId: item.documentResourceId,
							yzType: '1',
							crumFlag: 1,
							tabFtxt: a
						}
					});
				}
			}
		}
	},
	beforeRouteEnter(to, from, next) {
		if (from.meta.name) {
			names = from.meta.name;
			console.log(names, 96662);
		}
		next();
	},
	mounted() {
		console.log('组件首次挂载');
		const { type, txt, flags, yzType, classType, treFlag, tabFtxt } = this.$route.query;
		if (tabFtxt) {
			console.log(7777);
			this.a = typeof tabFtxt == 'string' ? ['首页', tabFtxt] : tabFtxt;
		}
		this.treFlag = treFlag === 'false' ? false : true;
		this.type = type || 1;
		this.classType = classType || 2;
		this.txt = txt || '';
		this.yzType = yzType || '';
		this.flags = flags || '';
		this.init();
	},
	activated() {
		console.log('组件被激活（从缓存恢复）');
	}
};
</script>
<style lang="scss" scoped>
.zzAdminTabs {
	height: 50px;
	background: #ffffff;
	border-radius: 6px 6px 0px 0px;
	display: flex;
	justify-content: space-between;
	padding: 0 15px 0 26px;
	border-bottom: 1px solid #f3f4f7;
	align-items: center;
	.zzAdminTabZj {
		font-size: 14px;
		span {
			color: #1d7b3a;
		}
	}
	.zzAdminTab {
		display: flex;
		font-size: 18px;
		color: #979797;
		align-items: center;
		.zzAdminItem {
			margin-right: 52px;
			cursor: pointer;
		}
		.active {
			color: #000;
			font-weight: bold;
		}
	}
	.zzAdminUp {
		display: flex;
		align-items: center;
		color: #1d7b3a;
		font-size: 14px;
		height: 100%;
		cursor: pointer;
		img {
			width: 16px;
			height: 16px;
			margin-right: 7px;
		}
	}
}
.zzAdminConts {
	background: #ffffff;
	border-radius: 0px 0px 6px 6px;
	padding: 0 15px;
	.zzAdminCont {
		margin-bottom: 10px;
		min-height: 400px;
		.zzAdminG {
			display: flex;
			padding: 15px 0;
			border-bottom: 1px solid #f8f8f8;
			align-items: center;
			&:last-of-type {
				border-bottom: none;
			}
			.zzAdminItemImg {
				width: 100px;
				height: 100px;
				margin-right: 10px;
			}
			.zzAdminItemImg1 {
				width: 65px;
				height: 65px;
			}
			.zzAdminItemImg2 {
				width: 155px;
				height: 85px;
			}
			.zzAdminItemP {
				flex: 1;
				padding-right: 30px;
				cursor: pointer;
				.zzAdminItemJj {
					display: flex;
					align-items: center;
					.zzAdminItemJjI {
						padding: 0 10px;
						height: 20px;
						font-size: 12px;
						text-align: center;
						line-height: 20px;
						border-radius: 4px;
						margin-right: 10px;
						margin-bottom: 5px;
					}
					.zzAdminItemJjI0 {
						background: #f6fcf1;
						color: #5ec009;
					}
					.zzAdminItemJjI1 {
						background: #fef7f0;
						color: #f7860f;
					}
					.zzAdminItemJjI2 {
						background: #f6fcf1;
						color: #5ec009;
					}
					.zzAdminItemJjI3 {
						background: #f1f7fe;
						color: #1675e5;
					}
					.zzAdminItemJjI4 {
						background: #fbf3ff;
						color: #bf2ff9;
					}
					.zzAdminItemJjI5 {
						background: #f2f7f3;
						color: #1d7b3a;
					}
				}
				.zzAdminItemCont {
					font-size: 14px;
					margin-bottom: 5px;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
					text-overflow: ellipsis;
				}
				.zzAdminItemFot {
					display: flex;
					align-items: center;
					.zzAdminItemk {
						display: flex;
						align-items: center;
						color: #8f9190;
						font-size: 12px;
						margin-right: 29px;
						img {
							width: 15px;
							height: 15px;
							margin-right: 4px;
						}
					}
				}
				.zzAdminItemC {
					color: #aeaeae;
					font-size: 14px;
					width: 647px;
					margin-bottom: 5px;
					overflow: hidden; /* 确保超出容器的内容被裁剪 */
					white-space: nowrap; /* 确保文本在一行内显示 */
					text-overflow: ellipsis; /* 超出部分显示省略号 */
				}
				.zzAdminItemTit {
					display: flex;
					align-items: center;
					margin-bottom: 6px;
					.zzAdminItemStat {
						width: 44px;
						height: 20px;
						background: #1d7b3a;
						font-size: 14px;
						color: #fff;
						margin-right: 10px;
						border-radius: 4px;
						text-align: center;
						line-height: 20px;
					}
					p {
						flex: 1;
						font-size: 16px;
						color: #000000;
						font-weight: bold;
						// max-width: 520px;
						// overflow: hidden; /* 确保超出容器的内容被裁剪 */
						// white-space: nowrap; /* 确保文本在一行内显示 */
						// text-overflow: ellipsis; /* 超出部分显示省略号 */
					}
					.infoMyIcon {
						display: flex;
						align-items: center;
						color: #93571c;
						font-size: 14px;
						margin-left: 14px;
						img {
							width: 14px;
							height: 14px;
							margin-right: 4px;
						}
					}
					.zzAdminItemYuy {
						display: flex;
						align-items: center;
						color: #999999;
						font-size: 14px;
						margin-left: 25px;
						line-height: 1;
						img {
							width: 14px;
							height: 14px;
							vertical-align: bottom;
							margin-right: 5px;
						}
					}
					.active {
						color: #1d7b3a;
					}
				}
			}
			.zzAdminItemDel {
				width: 75px;
				height: 30px;
				background: #1d7b3a;
				margin-right: 14px;
				cursor: pointer;
				text-align: center;
				line-height: 30px;
				color: #fff;
				border-radius: 6px;
				font-size: 14px;
				margin-top: -7px;
				a {
					width: 100%;
					height: 100%;
				}
			}
		}
	}
}
.gxBox {
	width: 1200px;
	margin: 0 auto 10px;
	display: flex;
	min-height: calc(100vh - 394px);
	.gxBoxL {
		width: 230px;
		background: #ffffff;
		border-radius: 6px;
		padding: 17px 14px 0;
		margin-right: 10px;
	}
	.gxBoxR {
		flex: 1;
		.gxBoxRT {
			background: #ffffff;
			border-radius: 6px;
			margin-bottom: 10px;
			padding: 17px 17px 11px;
			.gxBoxRTbox {
				margin-top: 20px;
				display: flex;
				flex-wrap: wrap;
				max-height: calc(36px + 10px + 36px);
				overflow: hidden;
				.gxBoxRTitem {
					padding: 0 10px;
					height: 36px;
					background: #f3f4f7;
					border-radius: 4px;
					text-align: center;
					line-height: 36px;
					color: #000000;
					font-size: 14px;
					cursor: pointer;
					margin-right: 26px;
					margin-bottom: 10px;
					// &:nth-of-type(9n){
					//   margin-right: 0;
					// }
				}
				.active {
					background: #e5f2e9;
					color: #1d7b3a;
				}
			}
			.gxBoxRTit {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 14px;
				color: #949494;
				h2 {
					font-weight: normal;
					font-size: 14px;
				}
				span {
					display: flex;
					align-items: center;
					cursor: pointer;
				}
				img {
					width: 16px;
					height: 16px;
					margin-right: 4px;
				}
			}
		}
	}
}
.infoMyVip {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 75px;
	height: 18px;
	background: linear-gradient(90deg, #fde6d1 0%, #fdd7b3 100%);
	border-radius: 4px;
	color: #93571c;
	font-size: 12px;
	margin-left: 10px;

	img {
		width: 14px;
		height: 14px;
		margin-right: 2px;
	}
}
.infoMyPut {
	background: linear-gradient(90deg, rgba(97, 161, 255, 0.22) 0%, rgba(0, 118, 255, 0.31) 100%);
	color: #0c7bfd;
	i {
		font-size: 14px;
		margin-right: 2px;
		line-height: 1.2;
	}
}
.zzAdminItemFot {
	display: flex;
	align-items: center;
	.zzAdminItemk {
		display: flex;
		align-items: center;
		color: #8f9190;
		font-size: 12px;
		margin-right: 29px;
		img {
			width: 15px;
			height: 15px;
			margin-right: 4px;
		}
	}
}
.zzAdminItemFot1 {
	margin-bottom: 7px;
	.zzAdminItemk {
		color: #333333;
	}
}
.zzAdminItemDel1 {
	margin-top: 0 !important;
	height: 24px !important;
	line-height: 24px !important;
	width: 65px !important;
}
</style>
